"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __importDefault(require("events"));
var Linking = /** @class */ (function () {
    function Linking() {
        this.emitter = new events_1.default();
    }
    Linking.prototype.emit = function (event, value) {
        this.emitter.emit(event, value);
    };
    Linking.prototype.addEventListener = function (event, callback) {
        this.emitter.on(event, callback);
    };
    Linking.prototype.removeEventListener = function (event, callback) {
        this.emitter.off(event, callback);
    };
    Linking.prototype.openURL = function (url) {
        window.location.href = url;
    };
    return Linking;
}());
var linking = new Linking();
exports.default = linking;
//# sourceMappingURL=linking.js.map